import axios from "axios";
import React, { useEffect, useState } from "react";
import styles from "./styles.css";
import Select from "react-select";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Label,
} from "reactstrap";
import { URL_API } from "variable";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { IMAGE_URL } from "variable";

toast.configure();

function MakerEdit() {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
      [{ align: [] }],
      ["code-block"],
    ],
  };

  const formats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "align",
    "code-block",
  ];

  const id = useParams();
  const history = useHistory();

  const [name, setName] = useState();
  const [description, setDescription] = useState("");
  const [metaTitle, setMetaTitle] = useState();
  const [keyword, setKeyword] = useState();
  const [metaDescription, setMetaDescription] = useState();

  const [image, setImage] = useState();
  const [heroImage, setHeroImage] = useState();
  const [maker, setMaker] = useState();

  useEffect(() => {
    getMaker();
    let token = localStorage.getItem("token");
  }, []);

  const onNameChange = (e) => {
    setName([e.target.value]);
  };

  const onDescChange = (e) => {
    setDescription([e.target.value]);
  };

  const onImageChange = (event) => {
    if (!event.target.files[0]) {
      return false;
    } else {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      setImage(files[0]);
    }
  };

  const onMetaTitleChange = (e) => {
    setMetaTitle([e.target.value]);
  };

  const onKeywordChange = (e) => {
    setKeyword([e.target.value]);
  };

  const onMetaDescriptionChange = (e) => {
    setMetaDescription([e.target.value]);
  };



  const getMaker = () => {
    axios
      .get(URL_API + `auth/admin/vehicles/${id.id}/edit`)
      .then((response) => {
        console.log("vehicle edit", response.data.vehicle);
        if (response.data.status === 200) {
          setMaker(response.data.vehicle);
          setName(response.data.vehicle.vehicle_name);
          setDescription(response.data.vehicle.description);
          setImage(response.data.vehicle.image);
          setHeroImage(response.data.vehicle.hero_image);
          setMetaTitle(response.data.vehicle.meta_title);
          setKeyword(response.data.vehicle.keywords);
          setMetaDescription(response.data.vehicle.meta_description);
        }
      });
  };

  const onHeroImageChange = (event) => {
    if (!event.target.files[0]) {
      return false;
    } else {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      setHeroImage(files[0]);
    }
  };

  const onSubmit = (event) => {
    event.preventDefault();

    let formData = new FormData();

    
    formData.append("vehicle_name", name);
    formData.append("image", image);
    formData.append("hero_image", heroImage);
    formData.append("description", description);
    // formData.append("description", description.replace(/<[^>]+>/g, ""));
    formData.append("meta_title", metaTitle);
    formData.append("keywords", keyword);
    formData.append("meta_description", metaDescription);

    axios
      .post(URL_API + `auth/admin/vehicles/update-vehicle/${id.id}`, formData)
      .then((response) => {
        if (response.status == 200) {
          history.push("/admin/makes");
          toast.success("Maker Updated Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="content">
        <form onSubmit={(e) => onSubmit(e)}>
          <div className={`container-fluid`}>
            <div className={styles.HeroiImgBlogForm}>
              <div className={styles.paddingTopBottomBlogForm}>
                <h3 className={styles.HeroiImgTextBlogForm}>Update Maker</h3>
              </div>
            </div>
            <br />
            <div className="container">
              <div className={`form ${styles.blogPostForm}`}>
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Name
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    placeholder="audi"
                    value={name}
                    onChange={(e) => onNameChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="post-Images" className={styles.labelPostForm}>
                    Upload Maker Icon
                  </label>
                  <Input
                    id="image"
                    type="file"
                    name="image"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    onChange={(e) => onImageChange(e)}
                    
                  />
                </div>

                <div className="form-group">
                  <label
                    htmlFor="post-Images"
                    className={styles.labelPostForm}
                    style={{ paddingRight: "20px" }}
                  >
                    Current Maker Icon
                  </label>
                  <img
                    height="100px"
                    width="100px"
                    src={IMAGE_URL + maker?.image}
                  />
                </div>

                <ReactQuill
                  onChange={(value) => {
                    setDescription(value);
                  }}
                  value={description}
                  modules={modules}
                  formats={formats}
                  placeholder="Enter Maker Description"
                  
                />

                <div className="form-group">
                  <label htmlFor="post-Images" className={styles.labelPostForm}>
                    Upload Hero Image
                  </label>
                  <Input
                    id="image"
                    type="file"
                    name="hero_image"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    onChange={(e) => onHeroImageChange(e)}
                    
                  />
                </div>

                <div className="form-group">
                  <label
                    htmlFor="post-Images"
                    className={styles.labelPostForm}
                    style={{ paddingRight: "20px" }}
                  >
                    Current Hero Image
                  </label>
                  <img
                    height="100px"
                    width="200px"
                    src={IMAGE_URL + maker?.hero_image}
                  />
                </div>

                <br />

                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Meta Title
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    value={metaTitle}
                    onChange={(e) => onMetaTitleChange(e)}
                  />
                </div>
                <br />

                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Meta Keywowrds
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    value={keyword}
                    onChange={(e) => onKeywordChange(e)}
                  />
                </div>
                <br />

                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Meta Description
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    value={metaDescription}
                    required="required"
                    onChange={(e) => onMetaDescriptionChange(e)}
                  />
                </div>
                <br />


                <Input
                  type="submit"
                  name="submit"
                  className={`btn btn-danger ${styles.blogPostFormBtn}`}
                  value="Submit"
                />
              </div>
              <br />
              <br />
            </div>
          </div>
          {/* <BlogForm handleChange={handleChange} /> */}
        </form>
      </div>
    </>
  );
}

export default MakerEdit;
